import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from "@angular/core";
import { UntypedFormGroup,UntypedFormBuilder } from "@angular/forms";
import { HttpClient } from '@angular/common/http';
import { LoginService } from "../login.service";
import { SettingsService } from "../settings.service";

@Component({
    selector: 'app-rooms',
    templateUrl: './rooms.component.html',
    styleUrls: ['./rooms.component.scss'],
    standalone: false
})
export class RoomsComponent implements OnInit {
  @Output() closed = new EventEmitter();
  roomForm:UntypedFormGroup
  exams:any[]=[]
  dateRangeError: string = ''
  constructor(private fb:UntypedFormBuilder,
    private http: HttpClient,
    public settings:SettingsService,
    public ls:LoginService) { }

  ngOnInit(): void {
    this.roomForm = this.fb.group({
      RoomName: [''],
      roomType: ['exam'],
      isOneTime: [false],
      oneTimeDate: [null],
      oneTimeDateTo: [null],
      oneTimeExamType: [null]
    });
    this.settings.getExams().then((data)=>{ this.exams = data || [] });
  }

  getExamName(exam): string {
    return exam.custom ? exam.examType : exam.examName;
  }

  closeRooms(){
    this.closed.emit()
  }


  private validateOneTimeRange(v: any): string {
    if (!v.isOneTime) return '';
    if (!v.oneTimeDate || !v.oneTimeDateTo) return 'יש למלא תאריך התחלה וסיום';
    const diffDays = (new Date(v.oneTimeDateTo).getTime() - new Date(v.oneTimeDate).getTime()) / (1000 * 60 * 60 * 24);
    if (diffDays < 0) return 'תאריך הסיום חייב להיות גדול או שווה לתאריך ההתחלה';
    if (diffDays > 6) return 'טווח החדר הזמני לא יכול לעלות על שבוע';
    return '';
  }

  saveRoom(){
    this.dateRangeError = this.validateOneTimeRange(this.roomForm.value);
    if (this.dateRangeError) return;
    this.http.post('/api/rooms',this.roomForm.value).subscribe((data: string) => {
     this.ls.rooms.push(data);
     this.ls.room=data['AutoIndex']
     // For a one-time room, link the new room to the chosen exam so the exams
     // page reflects the association without the user opening it.
     this.associateExam(data['AutoIndex'])
     this.closeRooms()
    })
  }

  private associateExam(roomId){
    const value = this.roomForm.value
    if (!value.isOneTime || !value.oneTimeExamType) return
    const exam = (this.exams || []).find(e => e.AutoIndex == value.oneTimeExamType)
    if (!exam) return
    const users = Array.isArray(exam.users) ? [...exam.users] : []
    if (!users.map(String).includes(String(roomId))) {
      users.push(roomId)
    }
    this.settings.updateExam({ ...exam, users })
      .catch(err => console.error('Failed to associate room with exam', err))
  }
}
